import { OnInit, Component } from "@angular/core";
import { PublishPortalService, Portals } from "app/infrastructure/services/publishPortal.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
    selector: 'sx-publish-portals',
    templateUrl: './portals.component.html',
    styleUrls: ['./portals.component.css']
})

export class PortalsComponent implements OnInit {  
    portals: Portals = <Portals>{};

    constructor(
        private portalService: PublishPortalService,
        private router: Router,
        private aRoute: ActivatedRoute
      ) {}
      
    ngOnInit() {
        this.getAllPortals();
    }

    getAllPortals() {
        this.portalService
          .getAllPortals()
          .subscribe(res => {
            this.portals = res;
        });
    }

    goBack() {
        this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
    }

}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/portals/portals.component.ts